import { render } from "./JourneyDetailsPage.vue?vue&type=template&id=5430794e&scoped=true"
import script from "./JourneyDetailsPage.vue?vue&type=script&lang=js"
export * from "./JourneyDetailsPage.vue?vue&type=script&lang=js"

import "./JourneyDetailsPage.vue?vue&type=style&index=0&id=5430794e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5430794e"]])

export default __exports__